module.exports = __webpack_public_path__ + "files/2f79af7ac322931437963da08e5725b2.svg";